import { client } from "utils";

export const getTestCaseReportRequest = (id) => client.get(`config-ci-test-case-task/${id}/report`);

export const restartTestCaseReportRequest = (id) => client.patch(`config-ci-test-task/${id}/restart`, {});
